import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { Input } from '../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
import ComboBox from '../../../Components/ComboBox'
import EditOperationForm from './EditOperationForm'
import PlanifierRecette from './PlanifierRecette'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ShareIcon from '@mui/icons-material/Share'
import DifferenceIcon from '@mui/icons-material/Difference'
import CreateMessage from 'containers/MyInbox/CreateMessage'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export const MesRecettes = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [mOpen, setMOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [infoshow, setInfoShow] = useState(true)
  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  const [loading, setLoading] = useState(false)
  const [types, setTypes] = useState([])
  const [categorie, setCategorie] = useState([])
  const [plat, setPlat] = useState([])
  const [cuisine, setCuisine] = useState([])
  const [repas, setRepas] = useState([])
  const [general, setGeneral] = useState(true)
  const [selected, setSelected] = useState(false)
  const [openForm, setOpenForm] = useState(false)
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Nom: '',
      Categorie: '',
      TypeDeCuisine: '',
      TypeDePlat: '',
      TypeDeRepas: '',
    },
  })

  useEffect(() => {
    fetchOperations()
    fetchFilters()
  }, [location.search])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudRecettesOperations}?general=${general}&${location.search.slice(1)}`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const fetchOperations2 = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudRecettesOperations}?general=${general}&${location.search.slice(1)}`
    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({
        ...response.data,
        results: [...operations.results, ...response.data.results],
      })
      setLoading(false)
    }
    setLoading(false)
  }

  const filterOperations = (data) => {
    setGeneral(false)
    let s = {
      ...data,
      TypeDeRepas: data.TypeDeRepas ? data.TypeDeRepas.label : '',
      Categorie: data.Categorie ? data.Categorie.id : '',
      TypeDeCuisine: data.TypeDeCuisine ? data.TypeDeCuisine.id : '',
      TypeDePlat: data.TypeDePlat ? data.TypeDePlat.id : '',
    }

    const queryParams = new URLSearchParams(s).toString()

    navigate(`?${queryParams}`)
  }

  const handelPlanifier = async () => {
    if (selectedRows.length === 0) {
      // LAP-733 (GE022)
      alert(t('recipes.alertSelectOne'))
    } else if (selectedRows.length > 1) {
      // LAP-733 (GE022)
      alert(t('recipes.alertSelectOnlyOne'))
    } else {
      setOpenForm(true)
    }
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      // LAP-733 (GE022)
      alert(t('recipes.alertSelectOne'))
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkRecetteOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }

  const fetchFilters = async () => {
    const url = urls.getFilters
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setCategorie(data.category)
      setPlat(data.plat)
      setCuisine(data.cuisine)
      setRepas(data.repas)
    }
  }

  const clearFilter = () => {
    setGeneral(true)
    navigate(``)

    let v = document.getElementsByClassName('MuiAutocomplete-clearIndicator')
    if (v.length > 0) v[0].click()
    reset()
  }

  return (
    <>
      {mOpen && (
        <CreateMessage
          setMOpen={setMOpen}
          /* LAP-733 (GE022) */
          title={t('recipes.shareTitle')}
          settingId={6}
          recette={operations.results.filter((v) => v.id === selectedRows[0])[0]}
        />
      )}
      {openForm && <PlanifierRecette setOpenForm={setOpenForm} row={selectedRows[0]} />}
      <Box bgcolor={'#001b42'} p={1}>
        {/* <Container maxWidth="xl" sx={{ display: infoshow ? 'block' : 'none' }}>
          <form onSubmit={handleSubmit(filterOperations)}>
            <Box display={'flex'} flexWrap="wrap">
              <Input
                classAttr="_input"
                control={control}
                name="Nom"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                label="Nom"
              />
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('Categorie', j)
                }}
                label="Catégorie"
                data={categorie}
                name="Categorie"
              />
              <ComboBox
                sx={{ marginLeft: '10px' }}
                handleAutoComplete={(e, j) => {
                  setValue('TypeDeRepas', j)
                }}
                label="Type de repas"
                data={repas}
                name="TypeDeRepas"
              />
              <ComboBox
                sx={{ marginLeft: '20px' }}
                handleAutoComplete={(e, j) => {
                  setValue('TypeDePlat', j)
                }}
                label="Type de plat"
                data={plat}
                name="TypeDePlat"
              />
              <ComboBox
                sx={{ marginLeft: '30px' }}
                handleAutoComplete={(e, j) => {
                  setValue('TypeDeCuisine', j)
                }}
                label="Ingrédients"
                data={cuisine}
                name="TypeDeCuisine"
              />

              <CustomButton
                type="submit"
                sx={{
                  color: 'white',
                  height: '20px',
                  marginTop: 'auto',
                  marginBlock: 'auto',
                  marginLeft: '35px',
                  '&:hover': { color: 'black', backgroundColor: 'white' },
                }}
              >
                Filter
              </CustomButton>
              <CustomButton
                onClick={clearFilter}
                sx={{
                  color: 'white',
                  height: '20px',
                  marginTop: 'auto',
                  marginBlock: 'auto',
                  marginLeft: '15px',
                  '&:hover': { color: 'black', backgroundColor: 'white' },
                }}
              >
                Clear Filter
              </CustomButton>
            </Box>
          </form>
        </Container> */}
        <Box display={'flex'} justifyContent={'center'} mt={1}>
          {isMobile && (
            <>
              {infoshow ? (
                <KeyboardArrowUpIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              )}
            </>
          )}
        </Box>
      </Box>

      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          {isMobile ? (
            <Box color={'white'} display={'flex'} gap={2}>
              <DifferenceIcon onClick={() => navigate('/recette-category')} />

              <ShareIcon />
              <CalendarMonthIcon onClick={handelPlanifier} />
              <CreateOperationForm setOperations={setOperations} />
              <RemoveCircleIcon onClick={deleteBulkOperations} />
              <EditIcon
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    /* LAP-733 (GE022) */ alert(t('recipes.alertSelectOneToEdit'))
                  }
                }}
              />
            </Box>
          ) : (
            <Box>
              <CustomButton onClick={() => navigate('/recette-category')}>
                {/* LAP-733 (GE022) */}
                {t('recipes.btnCategories')}
              </CustomButton>
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setMOpen(true)
                  } else {
                    /* LAP-733 (GE022) */ alert(t('recipes.alertSelectOneToShare'))
                  }
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('recipes.btnShare')}
              </CustomButton>
              {/* LAP-733 (GE022) */}
              <CustomButton onClick={handelPlanifier}>{t('recipes.btnPlan')}</CustomButton>
              <CreateOperationForm setOperations={setOperations} />
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    /* LAP-733 (GE022) */ alert(t('recipes.alertSelectOneToEdit'))
                  }
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('recipes.btnEdit')}
              </CustomButton>

              {/* LAP-733 (GE022) */}
              <CustomButton onClick={deleteBulkOperations}>{t('recipes.btnDelete')}</CustomButton>
            </Box>
          )}
        </Box>
        <Box width={'100%'}>
          <ListOperations
            fetchOperations={fetchOperations}
            setSelectedRows={setSelectedRows}
            operations={operations}
            fetchOperations2={fetchOperations2}
          />
        </Box>
      </Container>
      {selected ? (
        <EditOperationForm
          setOperations={setOperations}
          setSelected={setSelected}
          params={selectedRowsParams}
          operations={operations}
          vehiculesTypes={types}
        />
      ) : (
        ''
      )}
    </>
  )
}
